import { organizationApi } from '@/api/super-admin/organization.api';

export const organizationService = {
  getOrganizations: async (page = 1, size = 10) => {
    const data = await organizationApi.getAll(page, size);
    return { data };
  },

  getOrganizationById: async (id) => {
    const data = await organizationApi.getById(id);
    return { data };
  },

  createOrganization: async (orgData) => {
    const data = await organizationApi.create(orgData);
    return { data };
  },

  updateOrganization: async (id, updates) => {
    const data = await organizationApi.update(id, updates);
    return { data };
  },
};
